import { RescheduleAI } from "@clockwise/web-commons/src/components/svgs/RescheduleAI";
import { Tooltip } from "@material-ui/core";
import React from "react";
import { AI_EXCLUSION_TOOLTIP } from "../../../chat/constants";
import { Chip } from "../../../chip";

export const QuickProposeNewTime = ({
  shouldExcludeAi,
  submitRescheduleMessage,
}: {
  shouldExcludeAi: boolean;
  submitRescheduleMessage: () => void;
}) => {
  return (
    <div className="cw-flex-col cw-pt-1">
      <div className="cw-body-sm cw-text-12 cw-font-semibold cw-text-subtle cw-pl-1">
        You don't have permission to change the event, but you can propose a new time to the event
        organizer.
      </div>
      <div className="cw-flex cw-flex-wrap cw-gap-1 cw-my-2 cw-px-1">
        {shouldExcludeAi ? (
          <Tooltip title={AI_EXCLUSION_TOOLTIP} placement="top">
            <ProposeNewTimeButton
              shouldExcludeAi={shouldExcludeAi}
              submitRescheduleMessage={submitRescheduleMessage}
            />
          </Tooltip>
        ) : (
          <ProposeNewTimeButton
            shouldExcludeAi={shouldExcludeAi}
            submitRescheduleMessage={submitRescheduleMessage}
          />
        )}
      </div>
    </div>
  );
};

const ProposeNewTimeButton = ({
  shouldExcludeAi,
  submitRescheduleMessage,
}: {
  shouldExcludeAi: boolean;
  submitRescheduleMessage: () => void;
}) => {
  return (
    <Chip
      sentiment="neutral"
      variant="solid"
      disabled={shouldExcludeAi}
      onClick={submitRescheduleMessage}
      startIcon={RescheduleAI}
    >
      Propose new time
    </Chip>
  );
};
